import TabSwitcher from "./TabSwitcher";

export default class Entry {
  constructor() {
    this.container = this.findContainer();
    this.forms = [];
    this.tabEn = null;
    this.tabTitle = null;
    this.emptyMessage = null;
    this.tabSwitcher = null;
  }

  start() {
    this.container = this.findContainer();
    if (!this.container) return;

    this.forms = Array.from(this.container.querySelectorAll('.entry-content__form .wpcf7'));
    this.tabEn = this.container.querySelector('.js-entry-tab-en');
    this.tabTitle = this.container.querySelector('.js-entry-tab-title');
    this.emptyMessage = this.container.querySelector('.js-entry-form-empty');

    this.tabSwitcher = new TabSwitcher({
      findContainer: () => this.container,
      buttonSelector: '.js-entry-tab, .entry-tab-nav__button',
      normalizeTabKey: (tabKey) => this.normalizeTabKey(tabKey),
      onTabActivated: ({ button }) => {
        this.updateHeading(button);
        this.updateForms(button);
      },
    });
    this.tabSwitcher.start();
  }

  reset() {
    this.destruct();
    this.start();
  }

  destruct() {
    if (!this.tabSwitcher) return;
    this.tabSwitcher.destruct();
    this.tabSwitcher = null;
  }

  findContainer() {
    return (
      document.querySelector('.js-entry') ||
      document.querySelector('.entry-layout') ||
      document.querySelector('main.entry') ||
      null
    );
  }

  normalizeTabKey(tabKey) {
    if (!tabKey) return '';

    const normalized = String(tabKey).trim().toLowerCase();
    const aliasMap = {
      new: 'new_graduate',
      'new-graduate': 'new_graduate',
      new_graduate: 'new_graduate',
      graduate: 'new_graduate',
      mid: 'career',
      career: 'career',
      experienced: 'career',
    };

    return aliasMap[normalized] || normalized;
  }

  getButtonFormClass(button) {
    if (!button) return '';
    return (button.dataset.formClass || button.getAttribute('data-form-class') || '').trim();
  }

  getButtonEn(button) {
    if (!button) return '';
    return (button.dataset.tabEn || button.getAttribute('data-tab-en') || '').trim();
  }

  getButtonTitle(button) {
    if (!button) return '';
    return (button.dataset.tabTitle || button.getAttribute('data-tab-title') || '').trim();
  }

  updateHeading(activeButton) {
    if (!activeButton) return;

    const tabEnText = this.getButtonEn(activeButton);
    const tabTitleText = this.getButtonTitle(activeButton);

    if (this.tabEn && tabEnText !== '') {
      this.tabEn.textContent = tabEnText;
    }

    if (this.tabTitle && tabTitleText !== '') {
      this.tabTitle.textContent = tabTitleText;
    }
  }

  updateForms(activeButton) {
    if (!this.forms.length) {
      if (this.emptyMessage) {
        this.emptyMessage.removeAttribute('hidden');
      }
      return;
    }

    const targetFormClass = this.getButtonFormClass(activeButton);
    let activeFormCount = 0;

    this.forms.forEach((form) => {
      const isActive = this.hasTargetFormClass(form, targetFormClass);

      if (isActive) {
        form.removeAttribute('hidden');
        activeFormCount += 1;
      } else {
        form.setAttribute('hidden', 'hidden');
      }
    });

    if (this.emptyMessage) {
      if (activeFormCount > 0) {
        this.emptyMessage.setAttribute('hidden', 'hidden');
      } else {
        this.emptyMessage.removeAttribute('hidden');
      }
    }
  }

  hasTargetFormClass(formContainer, targetFormClass) {
    if (!formContainer || targetFormClass === '') return false;

    if (formContainer.classList.contains(targetFormClass)) {
      return true;
    }

    const innerForm = formContainer.querySelector('form.wpcf7-form, form');
    if (!innerForm) return false;

    return innerForm.classList.contains(targetFormClass);
  }
}
